import * as polished from 'polished';
import styled from 'styled-components';

type MarkerProps = {
  color: string;
};

export const MatchMarker = styled.div<MarkerProps>`
  position: relative;
  width: 36px;
  height: 36px;
  line-height: 36px;
  border-radius: 50%;
  background: ${(p: MarkerProps) => p.color};
  border: 2px solid ${(p: MarkerProps) => polished.lighten(0.2, p.color)};

  > svg {
    //top: 0.125rem;
  }

  > svg * {
    fill: white;
  }

  &:before {
    content: '';
    display: block;
    position: absolute;
    bottom: -5px;
    height: 5px;
    width: 3px;
    background: ${(p: MarkerProps) => p.color};
    left: 50%;
    margin-left: -2px;
    border-bottom-right-radius: 50%;
    border-bottom-left-radius: 50%;
  }
`;
